module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalTitle": 'Edit Tags Rule'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Name",
      "validation": "required"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("Rule")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "label": "Negated"
    },
    model: {
      value: (_vm.model.negated),
      callback: function($$v) {
        _vm.$set(_vm.model, "negated", $$v)
      },
      expression: "model.negated"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rule-wrapper"
  }, [_vm._l((_vm.model.terms), function(r, ix) {
    return _c('div', {
      staticClass: "rule",
      class: {
        operator: r.type == 'operator', tag: r.type == 'tag'
      }
    }, [(r.type == 'tag') ? _c('div', {
      staticClass: "header text-right"
    }, [_c('button', {
      on: {
        "click": function($event) {
          return _vm.removeTerm(ix)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "body"
    }, [(r.type == 'tag') ? _c('FormulateInput', {
      attrs: {
        "type": "select",
        "options": _vm.tagOptions,
        "placeholder": "Select tag"
      },
      model: {
        value: (r.value),
        callback: function($$v) {
          _vm.$set(r, "value", $$v)
        },
        expression: "r.value"
      }
    }) : _vm._e(), _vm._v(" "), (r.type == 'operator') ? _c('FormulateInput', {
      attrs: {
        "type": "select",
        "options": {
          'AND': 'AND',
          'OR': 'OR'
        }
      },
      model: {
        value: (r.value),
        callback: function($$v) {
          _vm.$set(r, "value", $$v)
        },
        expression: "r.value"
      }
    }) : _vm._e()], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "rule plus"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNextTerm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00183b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TagRuleModal.vue
// module id = 605
// module chunks = 0